module.exports = __webpack_public_path__ + "static/media/partner.065a0244.png";